<template>

<div class="py-32 w-full">    


    <div>Grid Type 1</div>
    <GridType1 />

    <div>Grid Type 1</div>
    <GridType2 />

</div>

</template>

<script setup>

import GridType1 from '../components/Blocks/GridType1.vue'
import GridType2 from '../components/Blocks/GridType2.vue'

</script>